export { UniversitiesSelector } from './UniversitiesSelector';
